<template>
  <div class="container-fluid mt-5">
    <card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">
          {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.ADD_ESTABLISHMENT_INTERNAL_ORDER") }}
        </h3>
        <base-button type="secondary" @click="goBack">
          {{ $t("COMMON.RETURN_TO_LIST") }}
        </base-button>
      </div>
      <establishment-internal-order-form
        :orderModel="order"
        :loading="loading"
        :submitLabel="$t('COMMON.SAVE')"
        @submit="submit"
      />
    </card>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import defaultOrder from "./defaultEstablishmentInternalOrder";
import EstablishmentInternalOrderForm from "./partials/EstablishmentInternalOrderForm.vue";

export default {
  name: "AddEstablishmentInternalOrderPage",
  components: { EstablishmentInternalOrderForm },
  data() {
    return {
      order: cloneDeep(defaultOrder),
      loading: false,
    };
  },
  created() {
    this.prefillFromQuery();
  },
  methods: {
    prefillFromQuery() {
      const { destination_establishment_id, week_starts_at } = this.$route.query;
      if (destination_establishment_id) {
        this.order.destinationEstablishment = {
          type: "establishments",
          id: destination_establishment_id,
        };
      }
      if (week_starts_at) {
        this.order.week_starts_at = week_starts_at;
      }
    },
    async submit(payload) {
      this.loading = true;
      try {
        await this.$store.dispatch("establishmentInternalOrders/add", { data: payload });
        const order = this.$store.getters["establishmentInternalOrders/order"];
        this.$notify({
          type: "success",
          message: this.$t("ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_INTERNAL_ORDER_ADDED"),
        });
        this.goToView(order.id);
      } finally {
        this.loading = false;
      }
    },
    goToView(id) {
      this.$router.push({ name: "View EstablishmentInternalOrder", params: { id } });
    },
    goBack() {
      this.$router.push({ name: "List EstablishmentInternalOrders" });
    },
  },
};
</script>
